var DetailGoeController = (function () {
    function DetailGoeController(topic, $scope, Dialog, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.env = env;
        this.lock = true;
        this.completeSection = 'goePick';
        this.comp = 'goe';
        this.updateArray = ['goe'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goeOptions = ['Yes', 'No', 'Unknown', 'State Owned'];
    }
    DetailGoeController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailGoeController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                var check = [{
                        id: this.topic.topic._id.substring(4),
                        name: 'INCGOE',
                        value: this.topic.temp.goe.picked
                    }];
                this.topic.sendForUpdateGeneral(this.updateArray, true, undefined, check);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailGoeController.$inject = ['topic', '$scope', 'Dialog', 'env'];
    return DetailGoeController;
}());
var DetailGoeComponent = (function () {
    function DetailGoeComponent() {
        this.templateUrl = 'detail-goe.html';
        this.controllerAs = 'vm';
        this.controller = DetailGoeController;
    }
    return DetailGoeComponent;
}());
angular
    .module('application')
    .component('goeSection', new DetailGoeComponent());

//# sourceMappingURL=detail.goe.component.js.map
